import ErrorManager from '@/common/utils/ErrorManager';
import { ERROR } from '@/modules/ErrorToaster/store/mutation-types';
import { RootState } from '@/plugins/store';
import { ActionTree } from 'vuex';
import SuiviFacturesService, { FacturesParams } from '../../../services/SuiviFacturesService';
import { SUIVI_FACTURES_EN_RETARD } from './mutation-types';
import { SuiviFacturesEnRetard, SuiviFacturesEnRetardActionTypes } from './action-types';
import { SuiviFacturesEnRetardState } from './state';
import { SuiviFacture } from '@/models/SuiviFacture';

export const actions: ActionTree<SuiviFacturesEnRetardState, RootState> = {
    async [SuiviFacturesEnRetard.GET_SUIVI_FACTURES_EN_RETARD](
        { commit }: SuiviFacturesEnRetardActionTypes,
        payload: FacturesParams
    ) {
        commit(SUIVI_FACTURES_EN_RETARD.SET_PAGE_EN_RETARD, payload.page);
        commit(SUIVI_FACTURES_EN_RETARD.SET_ERROR_EN_RETARD, undefined);
        commit(SUIVI_FACTURES_EN_RETARD.SET_IS_LOADING_EN_RETARD, true);
        try {
            const response = await SuiviFacturesService.getSuiviFacturesEnRetard(payload);
            if (response.status === 200 && response.data !== undefined) {
                if (payload.page === 0) {
                    commit(SUIVI_FACTURES_EN_RETARD.SET_ITEMS_EN_RETARD, response.data.content);
                    commit(SUIVI_FACTURES_EN_RETARD.SET_SCROLL, 0);
                    commit(SUIVI_FACTURES_EN_RETARD.SET_NB_OF_PAGES_EN_RETARD, response.data.totalPages || 0);
                    commit(SUIVI_FACTURES_EN_RETARD.SET_COUNT_EN_RETARD, response.data.totalElements || 0);
                } else {
                    commit(SUIVI_FACTURES_EN_RETARD.ADD_ITEMS, response.data.content);
                }
            } else {
                commit(
                    `errorToaster/${ERROR.SET_MESSAGE}`,
                    await ErrorManager.processErrorCustomMessage(response.status, 'app.error.undefined'),
                    { root: true }
                );
            }
            commit(SUIVI_FACTURES_EN_RETARD.SET_IS_LOADING_EN_RETARD, false);
        } catch (error) {
            commit(SUIVI_FACTURES_EN_RETARD.SET_IS_LOADING_EN_RETARD, false);
            commit(SUIVI_FACTURES_EN_RETARD.SET_ERROR_EN_RETARD, error);
            commit(`errorToaster/${ERROR.SET_MESSAGE}`, await ErrorManager.processError(error), { root: true });
        }
    },
    async [SuiviFacturesEnRetard.GET_FACTURES_EN_RETARD_PDF](
        { commit }: SuiviFacturesEnRetardActionTypes,
        factureToDownload: SuiviFacture
    ) {
        try {
            const response = await SuiviFacturesService.getFacturePdf(factureToDownload.numeroFacture, factureToDownload.societeId);
            if (response.status === 200 && response.data !== undefined) {
                const file = new Blob([response.data], { type: 'application/pdf' });
                const link = document.createElement('a');
                link.href = URL.createObjectURL(file);
                link.download = `${factureToDownload.numeroFacture}.pdf`;
                link.click();
            } else {
                commit(
                    `errorToaster/${ERROR.SET_MESSAGE}`,
                    await ErrorManager.processErrorCustomMessage(response.status, 'app.error.undefined'),
                    { root: true }
                );
            }
            commit(SUIVI_FACTURES_EN_RETARD.SET_IS_LOADING_EN_RETARD, false);
        } catch (error) {
            commit(SUIVI_FACTURES_EN_RETARD.SET_IS_LOADING_EN_RETARD, false);
            commit(SUIVI_FACTURES_EN_RETARD.SET_ERROR_EN_RETARD, error);
            commit(`errorToaster/${ERROR.SET_MESSAGE}`, await ErrorManager.processError(error), { root: true });
        }
    },
};
